module.exports = __webpack_public_path__ + "static/img/logo.efe46928.png";